module.exports = __webpack_public_path__ + "static/quiz_start_title_bg-e7a2ec3054e7d9fc13e87b0daeeaebd3.svg";